export default __webpack_public_path__ + "assets/icons/home_meun.b5b6080f.svg";